module.exports = __webpack_public_path__ + "img/宠物.41cccef3.jpg";